import { Container } from "@mui/material";
import React from "react";
import logo from "../assets/images/logo.svg";
import faceBook from "../assets/images/facebook.png";
import instagram from "../assets/images/instagram.png";
import linkdin from "../assets/images/linkdin.png";
import twitter from "../assets/images/twitter.png";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import footerlogo from "./../assets/images/yoloh-logo-dark.webp";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { useAuth } from "../context/AuthContext";

const Footer = ({ isPrivate }) => {
  const { authUser } = useAuth();

  return (
    <>
      {/* <div className="footer">
        <Container>
          <img
            width="136px"
            alt="Angular Logo"
            src={logo}
            className="logoMain"
            onClick={() => navigate("/")}
          />
          {!authUser?.attributes?.email && (
            <div className="footerLink">
              <Link to="/">
                <h3 className="active">Home</h3>
              </Link>
              <h3>|</h3>
              <ScrollLink
                to="about"
                spy={true}
                smooth={true}
                style={{ cursor: "pointer" }}
              >
                <h3>About Us</h3>
              </ScrollLink>
              <h3>|</h3>
              <Link to="/product">
                <h3>Products</h3>
              </Link>
            </div>
          )}

          <div className="footerLink">
            <a href="https://www.facebook.com/HappyYoloh" target="_blank">
              <img
                width="136px"
                alt="Angular Logo"
                src={faceBook}
                className="footerSocial"
              />
            </a>

            <a href="https://www.linkedin.com/company/yoloh" target="_blank">
              <img
                width="136px"
                alt="Angular Logo"
                src={linkdin}
                className="footerSocial"
              />
            </a>

            <a href="http://www.google.com" target="_blank">
              <img
                width="136px"
                alt="Angular Logo"
                src={instagram}
                className="footerSocial"
              />
            </a>

            <a href="http://www.google.com" target="_blank">
              <img
                width="136px"
                alt="Angular Logo"
                src={twitter}
                className="footerSocial"
              />
            </a>
          </div>
          <h5>
            It is a long established fact that a reader will be distracted by
            the readable content of a page when looking at its layout.
          </h5>
        </Container>
      </div>
      <div className="bottomFooter">
        <Container>
          <p>© 2022 Yoloh | Powered by Yoloh</p>
        </Container>
      </div> */}
      <section className="footer_section">
        <div className="container_width header_container">
          <div className="footer_details">
          
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <EmailOutlinedIcon />
              <p>connect@yoloh.com</p>
            </div>
            <div className="text-center">
               {/* <img src={footerlogo} alt="" width={100} /> */}
            
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
                fontSize: "18px",
                flexWrap: "wrap",
                marginTop: "5px"
              }}
              className="footerhover"
            >
              <a href="/licenses" style={{ fontFamily: "jokker-medium" }}>
                State Licenses
              </a>
              <span>|</span>

              <a href="/terms" style={{ fontFamily: "jokker-medium" }}>
                Terms and Conditions
              </a>
              <span>|</span>
              <a href="/privacy-policy" style={{ fontFamily: "jokker-medium" }}>
                Privacy policy
              </a>
            </div>
            </div>
            <p >Copyright @ 2023 - 2028</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
